import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "casSupervisors",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CasExternalSupervisorSetup/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const reducer = module.default;
        const key = module.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
